import { render, staticRenderFns } from "./News.vue?vue&type=template&id=40a0b281&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "./News.vue?vue&type=style&index=0&id=40a0b281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a0b281",
  null
  
)

export default component.exports